import React from "react";
import cx from "classnames";

import { Theme } from "@components/theme/Theme";

import * as ListItem from "../ListItem";
import styles from "../styles.module.css";

function WithImageOnRightAndRedTimestamp(props: ListItem.Props) {
  const { description, timestamp, image } = props;

  return (
    <article className={cx([styles.listItemContainer, styles.right])}>
      <div className={styles.leftColumn} data-skeleton-selector>
        {timestamp && (
          <Theme accentColor="red">
            <ListItem.Timestamp {...props} />
          </Theme>
        )}
      </div>
      <div className={styles.mainColumn} data-skeleton-selector>
        <ListItem.Text {...props} />
        {description && <ListItem.Description {...props} />}
      </div>
      <div className={styles.rightColumn} data-skeleton-selector>
        {image && <ListItem.Image {...props} />}
      </div>
    </article>
  );
}

WithImageOnRightAndRedTimestamp.displayName =
  "WithImageOnRightAndRedTimestamp.Component";

export { WithImageOnRightAndRedTimestamp };
